import React, { useEffect, useState } from 'react'
import { CentralAccordion } from '../../component/CentralAccordion/CentralAccordion'
import { useDispatch, useSelector } from 'react-redux';
import { centralCommonDataActions, centralPatientActions, centralReportingDataActions, configActions } from '../../../_actions';
import { CentralCommonHeader } from '../../component/CommonHeader/CentralCommonHeader';
import { useNavigate } from 'react-router-dom';
import { centralPatientConstants } from '../../../_constants/centralConstant/centralPatient.constant';
import { centralComplaintsActions } from '../../../_actions/centralActions/centralComplaints.actions';
import { hospitalDataConstants } from '../../../_constants';
import { Button, CircularProgress, Popover } from '@mui/material';
import { statusCategories } from '../../helpers/utilities';
import './centralPatientDetails.css'
import { centralEquipmentsActions } from '../../../_actions/centralActions/centralEquipments.actions';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const CentralPatientDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  let commonData = useSelector(state => state.centralCommonData.commonData)
  let activeHospitalId = useSelector(state=>state.centralHospitalData.activeHospitalId)

  let patientList = useSelector(state => state.centralPatients)
  let fetchedReportedData = useSelector(state => state.centralCommonData.commonData?.result.fetched)
  const reportingData = useSelector(state=>state.centralReportingData?.reportingData);
  const [activePatientName, setActivePatientName] = useState(patientList.activePatientName || '')
  const [patientJourneyTag,setPatientJourneyTag] = useState('')
  const [selectedColorObj,setSelectedColorObj] = useState([])
  const [activePatientId, setActivePatientId] = useState('');
  const [mainCategory, setMainCategory] = useState('')
  const [labTests, setLabTests] = useState([]);
  const [tag, setTag] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const parts = window.location.pathname.split('/');
    const id = parts[3]; 
    if(reportingData.message==='Success' && reportingData?.data?.length>0 && reportingData.data[0].appointment_id===id){
      const appointmentId = reportingData.data[0].appointment_id || reportingData.data[0]._id;
      setActivePatientId(appointmentId);
      setActivePatientName(reportingData.data[0].patient_name)
      activeHospitalId = reportingData.data[0].hospitalId
      const category = reportingData?.data[0]?.Category?.value
      setMainCategory(category)
      setLabTests(reportingData.data[0].labTests || []);
      setTag(reportingData.data[0].tag || '');

      reportingData?.data?.forEach(element => {
        if(element.appointment_id === activePatientId){
          const colorObj = statusCategories.filter((obj) =>
            obj.statuses.includes(element.patientJourneyTag)
          );
          setPatientJourneyTag(element.patientJourneyTag ? element.patientJourneyTag : '')
          setSelectedColorObj(colorObj)
        }
    });
    }
  }, [reportingData])
  
  const jsonData = commonData?.result?.data
  useEffect(() => {
   dispatch(centralCommonDataActions.getCentralCommonData())
   return ()=>dispatch(centralCommonDataActions.clearCentralCommonData())
  }, []);
  
  useEffect( () => {
    const parts = window.location.pathname.split('/');
      const id = parts[3]; 
      setActivePatientId(id);
      activeHospitalId = parts[2]
     dispatch(centralReportingDataActions.getCentralReportingData({"search_query":id}));
     dispatch(centralComplaintsActions.getCentralComplaintsList({"appId":id}))
     dispatch(
      centralEquipmentsActions.getCentralInstrumentsList({
        appId: id,
      })
    );
     if(window.location.search.includes("accessToken")){
       dispatch(centralPatientActions.getCentralPatientList({hospitalId:activeHospitalId}));
     }
  }, [activePatientId && jsonData]);

  useEffect(() => {
    activePatientName !== "" && dispatch({
        type:centralPatientConstants.SAVE_ACTIVE_CENTRAL_PATIENT_DATA,
        payload:{patientId:activePatientId,patientName:activePatientName}
    })
  }, [activePatientId, activePatientName])

  const [accordionHeaders,SetAccordionHeaders] = useState([])

  useEffect(()=>{
    if(jsonData){
      let payment_mode
      if(reportingData.message==='Success' && reportingData?.data?.length>0 ){
        payment_mode = reportingData?.data ? reportingData?.data[0]?.payment_mode : null ;
      }
        let tempArr = jsonData.map((item)=> {return item.title})
        if(tempArr && tempArr.length>0){
          if((payment_mode && (payment_mode?.toLowerCase()==='cashless' || payment_mode?.toLowerCase()==='reimbursement'))){
            SetAccordionHeaders(tempArr)
          }
          else{
            const titles = tempArr.filter(item=>item!=='Post Discharge Documents')
            SetAccordionHeaders(titles)
          }
        }
    }
  },[fetchedReportedData, reportingData])

  const handleBackButton = () =>{
    const parts = window.location.pathname.split('/');
    activeHospitalId = parts[2] || reportingData.data[0].hospitalId
    const hospitalName = reportingData?.data[0]?.hospitalName?.value
    if(activeHospitalId && hospitalName){
      dispatch({
          type:hospitalDataConstants.SAVE_ACTIVE_CENTRAL_HOSPITAL_DATA,
          payload:{id:activeHospitalId,hospitalName}
      })
  }
    navigate(`/central/${activeHospitalId}`)
    dispatch(centralCommonDataActions.clearCentralCommonData())
    dispatch({
      type:centralPatientConstants.SAVE_ACTIVE_CENTRAL_PATIENT_DATA,
      payload:null
  })
  }

  const handleJourneyNavigation = ()=>{
      navigate(`/central/patientJourney`)
  }

  const handleTagClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const getTagColor = () => {
    const colors = {
      'Major': '#DE4B4B',
      'Minor': '#f59e0b',
      'Emergency': '#ef4444'
    };
    return colors[tag] || '#DE4B4B';
  };

  return (
    <>
        <CentralCommonHeader title={activePatientName} backIcon={true} backArrowFunction = {handleBackButton} avatarIcon = {true} isChatIcon = {true} isCall={true}/>
        <div className='patientDetails_header'>
            {patientJourneyTag!='' ? <div className='patientDetails_statusCard' style={{backgroundColor:`${(selectedColorObj && selectedColorObj.length>0) ? selectedColorObj[0]?.color : ''}`,border:`0.1px solid ${(selectedColorObj && selectedColorObj.length>0) ? selectedColorObj[0]?.color : ''}`}}>
                {patientJourneyTag}
            </div> : <div></div>}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              {tag && (
                <>
                  <Button 
                    onClick={handleTagClick}
                    style={{
                      backgroundColor: getTagColor(),
                      color: 'white',
                      borderRadius: '20px',
                      padding: '5px 20px',
                      textTransform: 'none',
                      fontWeight: '500',
                      minWidth: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px'
                    }}
                  >
                    {tag}
                    <InfoOutlinedIcon style={{ fontSize: '18px' }} />
                  </Button>
                  <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    PaperProps={{
                      style: {
                        marginTop: '8px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        padding: '12px',
                        minWidth: '200px',
                        maxWidth: '300px',
                        maxHeight:'300px'
                      }
                    }}
                  >
                    {labTests && labTests.length > 0 && (
                      <>
                        <div style={{ 
                          fontSize: '14px', 
                          fontWeight: '600', 
                          marginBottom: '8px',
                          color: '#374151'
                        }}>
                          Lab Tests
                        </div>
                        <ul style={{ 
                          margin: 0, 
                          padding: '0 0 0 20px',
                          listStyleType: 'disc'
                        }}>
                          {labTests.map((test, index) => (
                            <li 
                              key={index}
                              style={{
                                fontSize: '13px',
                                color: '#6b7280',
                                marginBottom: '4px'
                              }}
                            >
                              {test}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </Popover>
                </>
              )}
              <Button className='patientDetails_journeyButton' onClick={handleJourneyNavigation}>
                Patient Journey
              </Button>
            </div>
        </div>
        <div className='patientDetailsMainContainer'>
  {fetchedReportedData && accordionHeaders && accordionHeaders.length > 0 && jsonData ? (
    <>
      {accordionHeaders.map((item, index) => {
        if (item === "Lens Details" && !mainCategory?.toLowerCase()?.includes("ophthal")) {
          return '';
        }
        return <CentralAccordion key={index} type={item} data={jsonData} />;
      })}
    </>
  ) : (
    <div className='patientDetailsLoaderContainer'>
      <CircularProgress />
    </div>
  )}
</div>
    </>
  )
}
